// Config/vistas.js
export const OPCIONES_VISTA = {
  Vehiculo: {
    titulo: "Vehiculo",
    descripcion: "Aquí se adjunta un vehículo al despacho creado, incluyendo la información técnica necesaria."
  },
  Ruta: {
    titulo: "Ruta",
    descripcion: "Aquí se configura la ruta que seguirá el despacho, especificando origen, destino y detalles."
  },
  Autorizaciones: {
    titulo: "Autorizaciones",
    descripcion: "Aquí se gestionan las autorizaciones necesarias para el despacho, como permisos especiales."
  },
  Conductores: {
    titulo: "Conductores",
    descripcion: "Aquí se registran los conductores asignados al despacho, junto con sus licencias y exámenes médicos."
  },
  Novedades: {
    titulo: "Novedades",
    descripcion: "Aquí se registran las novedades y eventos relacionados con los despachos."
  },
  Llegadas: {
    titulo: "Llegadas",
    descripcion: "Aquí se registran las llegadas y confirmaciones de los despachos."
  },
  LlegadasVehiculo: {
    titulo: "Llegadas Vehiculo",
    descripcion: "Aquí se muestra el listado de las llegadas de los vehículos."
  },
  LlegadasConductor: {
    titulo: "Llegadas Conductor",
    descripcion: "Aquí se muestra el listado de las llegadas de los conductores."
  },
   NovedadesVehiculo: {
    titulo: "Novedades Vehiculo",
    descripcion: "Aquí se muestra el listado de las Novedades de los vehículos."
    },
    NovedadesConductor: {
    titulo: "Novedades Conductor",
    descripcion: "Aquí se muestra el listado de las Novedades de los conductores."
  } 
};